import { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { cartActions } from '../redux/cart/actions';

export const useCartStore = (selector) => {
  const dispatch = useDispatch();
  const items = useSelector((state) => state.cart.items);

  const addItem = useCallback(
    (product, quantity = 1) => dispatch(cartActions.addItem(product, quantity)),
    [dispatch]
  );

  const removeItem = useCallback(
    (id) => dispatch(cartActions.removeItem(id)),
    [dispatch]
  );

  const updateQuantity = useCallback(
    (id, quantity) => dispatch(cartActions.updateQuantity(id, quantity)),
    [dispatch]
  );

  const clearCart = useCallback(
    () => dispatch(cartActions.clearCart()),
    [dispatch]
  );

  const getTotalItems = useCallback(
    () => items.reduce((sum, item) => sum + item.quantity, 0),
    [items]
  );

  const getTotalPrice = useCallback(
    () => items.reduce((sum, item) => sum + (item.price * item.quantity), 0),
    [items]
  );

  const storeShape = useMemo(
    () => ({
      items,
      addItem,
      removeItem,
      updateQuantity,
      clearCart,
      getTotalItems,
      getTotalPrice,
    }),
    [addItem, clearCart, getTotalItems, getTotalPrice, items, removeItem, updateQuantity]
  );

  return typeof selector === 'function' ? selector(storeShape) : storeShape;
};
